/* eslint-disable no-param-reassign */
import moment from "moment";
import { reconServiceAPI, afcsServiceAPI } from "./APIutils";
import { BASE_URL, AFCS_BASE_URL } from "../Constant";

export function fetchVehicleWiseCardCollection({
  cityFilter = [],
  operatorFilter = [],
  dateFilter = "",
  pageNo,
  pageSize = 10,
  searchString,
  sortBy = "",
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "vehicleWiseCardCollectionData",
    paramValue: {
      query: {
        id: "vehicleWiseCardCollectionData",
        sort: sortBy,
        ftsFilter: { $text: { $search: searchString } },
        addOnFilter: { cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function fetchDayWiseCardCollection({
  pageNo,
  pageSize = 10,
  cityFilter = [],
  operatorFilter = [],
  dateFilter = "",
  sortBy = "",
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "dayWiseCardCollectionData",
    paramValue: {
      query: {
        id: "dayWiseCardCollectionData",
        sort: sortBy,
        addOnFilter: { cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function fetchCardCollectionSummary({ cityFilter = [], operatorFilter = [], dateFilter = "" }) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "cardCollectionSummary",
    paramValue: {
      query: {
        id: "cardCollectionSummary",
        limit: 20,
        addOnFilter: { cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter },
      },
      model: "BusDayWise",
    },
  });
}

const fetchBody = (pageNo, pageSize, busNumber, dateFilter, fromDate, toDate) => {
  let reqUrl = `${AFCS_BASE_URL}`;
  const methodName = "ticketsissued";
  if (!(fromDate && toDate)) {
    fromDate = dateFilter && dateFilter.fromDate && parseFloat(moment(new Date(dateFilter.fromDate)).startOf("day").format("x"));
    toDate = dateFilter && dateFilter.toDate && parseFloat(moment(new Date(dateFilter.toDate)).endOf("day").format("x"));
  } else {
    fromDate = fromDate && new Date(fromDate).getTime();
    toDate = toDate && new Date(toDate).getTime();
  }
  reqUrl = `${methodName}?busNumber=${busNumber}&fromDate=${fromDate}&toDate=${toDate}&size=${pageSize}&page=${pageNo}`;
  const url = `${AFCS_BASE_URL}/${reqUrl}`;
  return afcsServiceAPI(url, {
    id: "ticketsissued",
  });
};

export function fetchTotalIssueTicket({
  pageNo,
  pageSize = 10,
  busNumber = "",
  dateFilter = "",
  fromDate = "",
  toDate = "",
}) {
  return fetchBody(pageNo, pageSize, busNumber, dateFilter, fromDate, toDate);
}

export function fetchCardIssued({
  pageNo,
  pageSize = 10,
  busNumber = "",
  dateFilter = "",
  fromDate = "",
  toDate = "",
}) {
  return fetchBody(pageNo, pageSize, busNumber, dateFilter, fromDate, toDate);
}

export function fetchCardRecharged({
  pageNo,
  pageSize = 10,
  busNumber = "",
  dateFilter = "",
  fromDate = "",
  toDate = "",
}) {
  return fetchBody(pageNo, pageSize, busNumber, dateFilter, fromDate, toDate);
}
